import server from '@/request';

export const tenantAccessStatistics = (data) => {
  return server.post('/xiaozi-saas/wireless/tenantAccessStatistics/pageList', data);
};

export const employeeAccessStatistics = (data) => {
  return server.post('/xiaozi-saas/wireless/employeeAccessStatistics/pageList', data);
};
